class Workspace {
  constructor(data) {
    this._id = data._id;
    this.name = data.name;
    this.updatePeriod = data.updatePeriod;
    this.nextUpdate = data.nextUpdate;
    this.avatarUrl = data.avatarUrl;
    this.coverUrl = data.coverUrl;
    this.slogan = data.slogan;
    this.welcomeMessage = data.welcomeMessage;
    this.admins = data.admins;
    this.emails = data.emails;
    this.onboardingHtml = data.onboardingHtml;
    this.lang = data.lang;
    this.status = data.status;
  }
}

export default Workspace;



// WEBPACK FOOTER //
// ./src/workspace/class.js